import type { ThemeBrightness, ThemeDefinition } from "./themeCatalog";

/** sRGB-Umrechnung und Relativluminanz nach WCAG 2.x. */
const RGB_HEX_OFFSETS = [1, 3, 5];
const HEX_CHANNEL_LENGTH = 2;
const HEX_RADIX = 16;
const MAX_CHANNEL_VALUE = 255;
const SRGB_LINEAR_THRESHOLD = 0.04045;
const SRGB_LINEAR_DIVISOR = 12.92;
const SRGB_GAMMA_OFFSET = 0.055;
const SRGB_GAMMA_SCALE = 1.055;
const SRGB_GAMMA_EXPONENT = 2.4;
const LUMA_RED = 0.2126;
const LUMA_GREEN = 0.7152;
const LUMA_BLUE = 0.0722;
/** Ab dieser Luminanz gilt die Fläche als hell (Kontrast zu Weiß und Schwarz gleich). */
const LIGHT_LUMINANCE_THRESHOLD = 0.179;

/** Marken liegen auf der Navigationsfläche; diese kann auch in einem hellen Theme dunkel sein. */
export function themeRailBrightness(theme: ThemeDefinition): ThemeBrightness {
  const color = theme.vars.rail;
  if (!/^#[\da-f]{6}$/i.test(color)) return theme.brightness;
  const channels = RGB_HEX_OFFSETS.map(offset => {
    const value = Number.parseInt(color.slice(offset, offset + HEX_CHANNEL_LENGTH), HEX_RADIX) / MAX_CHANNEL_VALUE;
    return value <= SRGB_LINEAR_THRESHOLD ? value / SRGB_LINEAR_DIVISOR : ((value + SRGB_GAMMA_OFFSET) / SRGB_GAMMA_SCALE) ** SRGB_GAMMA_EXPONENT;
  });
  const luminance = channels[0] * LUMA_RED + channels[1] * LUMA_GREEN + channels[2] * LUMA_BLUE;
  return luminance > LIGHT_LUMINANCE_THRESHOLD ? "light" : "dark";
}
